import Link from "next/link";
import { useRouter } from "next/router";

import { memo, useRef, useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Typography from "@mui/material/Typography";

import { PiGlobeHemisphereEastLight as Globe } from "react-icons/pi";

const getEmoji = (lang) => {
	switch (lang) {
		case "fr": {
			return "🇫🇷";
		}
		case "de": {
			return "🇩🇪";
		}
		default: {
			return "🇺🇸";
		}
	}
};

const LanguageMenu = memo(() => {
	const [popperOpen, setPopperOpen] = useState(false);
	const timeout = useRef<number>(-1);
	const anchorEl = useRef<typeof Box>(null);
	const { asPath, locale, locales } = useRouter();

	const handleClick = (_: any, shouldOpen: boolean) => {
		window.clearTimeout(timeout.current);
		timeout.current = window.setTimeout(() => {
			setPopperOpen(shouldOpen);
		}, 200);
	};

	return (
		<Box
			ref={anchorEl}
			onClick={(e) => handleClick(e, !popperOpen)}
			onMouseEnter={(e) => handleClick(e, true)}
			onMouseLeave={(e) => handleClick(e, false)}
			sx={{ marginRight: 2 }}
		>
			<Button
				disableElevation
				sx={{
					":hover": { border: "2px solid white" },
					alignItems: "center",
					backgroundColor: "transparent",
					color: "white",
					display: "flex",
					flexDirection: "row",
					gap: 1,
				}}
			>
				<Globe size={30} />
				<Typography>{locale?.toUpperCase()}</Typography>
			</Button>

			<Popper
				open={popperOpen}
				// @ts-expect-error: TODO
				anchorEl={anchorEl.current}
				transition
				onMouseEnter={(e) => handleClick(e, true)}
				onMouseLeave={(e) => handleClick(e, false)}
			>
				{({ TransitionProps }) => (
					<Fade {...TransitionProps} timeout={200}>
						<Paper sx={{ marginTop: 2 }}>
							<List>
								{locales?.map((loc) => (
									<ListItemButton key={loc}>
										<Link href={asPath} locale={loc} passHref legacyBehavior>
											<Box display="flex" flexDirection="row" gap={2}>
												{getEmoji(loc)}
												<Typography>{loc?.toUpperCase()}</Typography>
											</Box>
										</Link>
									</ListItemButton>
								))}
							</List>
						</Paper>
					</Fade>
				)}
			</Popper>
		</Box>
	);
});

LanguageMenu.displayName = "LanguageMenu";

export default LanguageMenu;
